import React from 'react'
import Video from '../../../video/shareplug.mp4'
import En_Video from '../../../video/en_shareplug.mp4'
import {Button} from '../ButtonElement'
import {
	HeroContainer,
	HeroBg,
	VideoBg,
	HeroContent,
	HeroP,
	HeroH1,
	HeroBtnWrapper,
  AnotherHeroContent
} from "./HeroElements"
import { useTranslation } from 'react-i18next'
const HeroSection = () => {

	const {t} = useTranslation();
	return (
		<HeroContainer id='home1'>
			<HeroBg>
				<VideoBg autoPlay loop muted src={localStorage.getItem('i18nextLng') ==="en" ? En_Video  : localStorage.getItem('i18nextLng') ==="ko" ? Video : null} type='video/shareplug.mp4'/>
			</HeroBg>
			<HeroContent>
				<HeroP>{t("Hero.p1")}<br/> {t("Hero.p2")} </HeroP>
				<HeroH1>{t("Hero.h1")}</HeroH1>
      </HeroContent>
      <AnotherHeroContent>
				<HeroBtnWrapper>
					<Button href='https://console.shareplug.co.kr' primary="true" target="_blank" rel="noopener noreferrer">{t("Hero.b1")} ></Button>
					<Button href='https://m.shareplug.co.kr/start'target="_blank" rel="noopener noreferrer" >{t("Hero.b2")} ></Button>				
        </HeroBtnWrapper>
			</AnotherHeroContent>
		</HeroContainer>
	)
}

export default HeroSection
